import { domToPng } from 'modern-screenshot'

const IGNORE_ATTRIBUTE = 'data-feedback-ignore'

/**
 * A PNG of the page as the user sees it, or null.
 *
 * The feedback button and dialog carry data-feedback-ignore and stay out of
 * the picture. A capture that fails (a cross-origin image, an exotic font) or
 * hangs must never block the report: after ``timeoutMs`` the dialog opens
 * without a screenshot.
 */
export async function captureScreenshot(
  root: HTMLElement = document.body,
  timeoutMs = 5000,
): Promise<string | null> {
  let timer: ReturnType<typeof setTimeout> | undefined
  try {
    return await Promise.race([
      domToPng(root, {
        scale: 1,
        filter: (node: Node) => !(node instanceof Element && node.hasAttribute(IGNORE_ATTRIBUTE)),
      }),
      new Promise<null>((resolve) => {
        timer = setTimeout(() => resolve(null), timeoutMs)
      }),
    ])
  } catch {
    return null
  } finally {
    clearTimeout(timer)
  }
}

export function dataUrlToBlob(dataUrl: string): Blob {
  const [header, data] = dataUrl.split(',', 2)
  const type = /^data:([^;,]+)/.exec(header)?.[1] ?? 'application/octet-stream'
  const binary = atob(data)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return new Blob([bytes], { type })
}
